/* Sticky product card: starts BELOW header strips at scroll=0, slides UP with scroll, sticks near top of viewport; stops before footer */
(function(){
  var card = document.querySelector('.product');
  var footer = document.querySelector('.footer-main');
  if (!card || !footer) return;
  var HEADER_BLOCK = 280;  // total header-strips height (topbar+header+researchbar+live-counter+article-meta)
  var STICKY_TOP = 24;     // where card sits when fully scrolled past header
  var BUFFER = 24;
  function getDynamicTop() {
    var s = window.pageYOffset;
    // Linearly slide from HEADER_BLOCK down to STICKY_TOP as user scrolls past the header strips
    if (s < HEADER_BLOCK - STICKY_TOP) return HEADER_BLOCK - s;
    return STICKY_TOP;
  }
  function check(){
    if (window.innerWidth < 1024) {
      card.style.position = '';
      card.style.top = '';
      return;
    }
    var footerTop = footer.getBoundingClientRect().top + window.pageYOffset;
    var cardHeight = card.offsetHeight;
    var threshold = footerTop - cardHeight - BUFFER;
    var TOP_OFFSET = getDynamicTop();
    if (window.pageYOffset > threshold - TOP_OFFSET) {
      card.style.position = 'absolute';
      card.style.top = threshold + 'px';
    } else {
      card.style.position = 'fixed';
      card.style.top = TOP_OFFSET + 'px';
    }
  }
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  check();
})();